import baseAction from './_base';
import {CONTACT_ADMIN} from './actionTypes';
import querystring from 'querystring';

export function contactAdmin(adminEmail) {
  let query = {};
  if (adminEmail) {
    query.adminEmail = adminEmail
  }
  return baseAction(CONTACT_ADMIN, '/v1/contact/admin/productAccessRequest?' + querystring.stringify(query));
}



/** WEBPACK FOOTER **
 ** ./src/_shared/actions/contactAdmin.js
 **/